/* LSL · collections : raccourcis, tri, filtres (Shopify + utilisation et personnage), « voir plus », barre mobile. */
(() => {
  'use strict';
  const root = document.querySelector('[data-c-root]'); if (!root) return;
  const $ = (s, r = root) => r.querySelector(s);
  const $$ = (s, r = root) => Array.from(r.querySelectorAll(s));
  const sectionId = root.dataset.sectionId, per = Number(root.dataset.per) || 20;
  const grid = $('[data-c-grid]'), status = $('[data-c-status]');
  const listOf = (sp, k) => sp.getAll(k).flatMap(v => v.split(',')).filter(Boolean);
  const sp0 = new URL(location.href).searchParams;
  const custom = { usage: new Set(listOf(sp0, 'lsl_usage')), character: new Set(listOf(sp0, 'lsl_character')) };
  const hasCustom = () => custom.usage.size + custom.character.size > 0;
  const nativeBase = () => { const u = new URL(location.href); ['lsl_usage', 'lsl_character', 'page', 'section_id'].forEach(k => u.searchParams.delete(k)); return u; };
  const go = u => { u.searchParams.delete('page'); location.href = u.toString(); };
  const plural = n => n + (n > 1 ? ' produits' : ' produit');

  /* Pastille du nombre de filtres actifs */
  const nActive = (Number(root.dataset.native) || 0) + custom.usage.size + custom.character.size;
  $$('[data-c-nfilters]').forEach(b => { b.textContent = nActive; b.hidden = nActive === 0; });

  /* Raccourcis : chaque appui ajoute ou retire un filtre dans l'adresse */
  $$('[data-c-chip]').forEach(ch => {
    const p = ch.dataset.param, v = ch.dataset.value;
    const single = p.indexOf('price') !== -1;
    const on = p.indexOf('lsl_') === 0 ? listOf(sp0, p).includes(v) : sp0.getAll(p).includes(v);
    ch.setAttribute('aria-pressed', String(on));
    ch.addEventListener('click', () => {
      const u = new URL(location.href);
      if (p.indexOf('lsl_') === 0) {
        const vals = new Set(listOf(u.searchParams, p)); if (on) vals.delete(v); else vals.add(v);
        u.searchParams.delete(p); if (vals.size) u.searchParams.set(p, Array.from(vals).join(','));
      } else if (single) {
        if (on) u.searchParams.delete(p); else u.searchParams.set(p, v);
      } else {
        const vals = u.searchParams.getAll(p).filter(x => x !== v); u.searchParams.delete(p);
        if (!on) vals.push(v); vals.forEach(x => u.searchParams.append(p, x));
      }
      go(u);
    });
  });

  /* Tri */
  $$('[data-c-sort]').forEach(sel => sel.addEventListener('change', () => { const u = new URL(location.href); u.searchParams.set('sort_by', sel.value); go(u); }));

  /* Panneau des filtres (tiroir sur mobile) */
  const panel = $('[data-c-panel]'), openers = $$('[data-c-open]');
  let opener = null;
  const isDrawer = () => !window.matchMedia('(min-width: 1100px)').matches;
  const openPanel = btn => {
    if (!panel) return; opener = btn; loadIndex().catch(() => {});
    if (!isDrawer()) { panel.scrollIntoView({ block: 'start' }); return; }
    panel.classList.add('is-open'); panel.setAttribute('role', 'dialog'); panel.setAttribute('aria-modal', 'true');
    document.documentElement.classList.add('c-lock'); openers.forEach(b => b.setAttribute('aria-expanded', 'true'));
    setTimeout(() => panel.focus({ preventScroll: true }), 30);
  };
  const closePanel = () => {
    if (!panel || !panel.classList.contains('is-open')) return;
    panel.classList.remove('is-open'); panel.removeAttribute('role'); panel.removeAttribute('aria-modal');
    document.documentElement.classList.remove('c-lock'); openers.forEach(b => b.setAttribute('aria-expanded', 'false'));
    if (opener) opener.focus({ preventScroll: true });
  };
  openers.forEach(b => b.addEventListener('click', () => openPanel(b)));
  $$('[data-c-close]').forEach(b => b.addEventListener('click', closePanel));
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closePanel(); });
  const form = $('[data-c-form]');
  if (form) form.addEventListener('submit', () => { $$('input', form).forEach(i => { if (!i.value || (i.type === 'number' && i.value === '')) i.disabled = true; }); });

  /* Index utilisation et personnage (section lsl-collection-filter-index, déjà utilisée par le thème) */
  let indexP = null;
  const idxStatus = $('[data-c-index-status]');
  const loadIndex = () => indexP || (indexP = (async () => {
    if (idxStatus) idxStatus.hidden = false;
    const items = []; let labels = {}; let url = nativeBase(); const seen = new Set();
    while (url) {
      url.searchParams.set('section_id', 'lsl-collection-filter-index');
      if (seen.has(url.toString())) break; seen.add(url.toString());
      const r = await fetch(url.toString(), { credentials: 'same-origin' });
      if (!r.ok) throw new Error('index');
      const doc = new DOMParser().parseFromString(await r.text(), 'text/html');
      const node = doc.querySelector('[data-lsl-index]'); if (!node) throw new Error('index');
      const data = JSON.parse(node.textContent);
      labels = data.usageLabels || labels;
      (data.items || []).forEach(it => { it.position = items.length; it.usage = (it.usage || []).filter(Boolean); items.push(it); });
      url = data.next ? new URL(data.next, url) : null;
    }
    if (idxStatus) idxStatus.hidden = true;
    populate(items, labels);
    return items;
  })().catch(e => { indexP = null; if (idxStatus) idxStatus.textContent = 'Les filtres n’ont pas pu se charger.'; throw e; }));
  const vals = (it, g) => g === 'usage' ? it.usage : (it.characters || []).map(c => c.key);
  const matches = (it, ignore) => ['usage', 'character'].every(g => g === ignore || custom[g].size === 0 || vals(it, g).some(v => custom[g].has(v)));
  function populate(items, labels) {
    const names = { usage: labels, character: {} };
    items.forEach(it => (it.characters || []).forEach(c => { names.character[c.key] = c.label; }));
    ['usage', 'character'].forEach(g => {
      const box = $('[data-c-opts="' + g + '"]'); if (!box) return;
      const rows = Object.keys(names[g]).map(k => [k, names[g][k], items.filter(it => matches(it, g) && vals(it, g).includes(k)).length]).filter(r => r[2] > 0 || custom[g].has(r[0]));
      if (g === 'character') rows.sort((a, b) => b[2] - a[2] || a[1].localeCompare(b[1]));
      box.replaceChildren(...rows.map(([k, l, n]) => {
        const lab = document.createElement('label'); lab.className = 'c-opt';
        const i = document.createElement('input'); i.type = 'checkbox'; i.name = 'lsl_' + g; i.value = k; i.checked = custom[g].has(k);
        const t = document.createElement('span'); t.textContent = l;
        const c = document.createElement('small'); c.textContent = n;
        lab.append(i, t, c); return lab;
      }));
      const grp = box.closest('[data-c-group]'); if (grp) grp.hidden = rows.length === 0;
    });
    $$('[data-c-chip][data-param="lsl_usage"]').forEach(ch => {
      const n = items.filter(it => it.usage.includes(ch.dataset.value)).length;
      if (n === 0 && ch.getAttribute('aria-pressed') !== 'true') ch.hidden = true;
    });
  }

  /* Filtres utilisation et personnage : on rassemble les bons produits de toutes les pages */
  async function applyCustom() {
    if (!grid) return;
    grid.setAttribute('aria-busy', 'true'); status.textContent = 'Chargement des sabres…';
    try {
      const items = await loadIndex();
      const hits = items.filter(it => matches(it));
      const cards = new Map();
      $$('[data-c-card]', grid).forEach(c => cards.set(c.dataset.handle, c));
      const pages = Array.from(new Set(hits.filter(it => !cards.has(it.handle)).map(it => Math.floor(it.position / per) + 1)));
      await Promise.all(pages.map(async pg => {
        const u = nativeBase(); u.searchParams.set('section_id', sectionId); u.searchParams.set('page', pg);
        const r = await fetch(u.toString(), { credentials: 'same-origin' }); if (!r.ok) throw new Error('page');
        const doc = new DOMParser().parseFromString(await r.text(), 'text/html');
        doc.querySelectorAll('[data-c-card]').forEach(c => { if (!cards.has(c.dataset.handle)) cards.set(c.dataset.handle, document.importNode(c, true)); });
      }));
      const list = hits.map(it => cards.get(it.handle)).filter(Boolean);
      grid.replaceChildren(...list);
      $$('[data-c-count]').forEach(e => { e.textContent = plural(list.length); });
      const more = $('[data-c-more-wrap]'); if (more) more.hidden = true;
      status.textContent = list.length ? '' : 'Aucun sabre ne correspond à ces filtres.';
    } catch (e) {
      status.textContent = 'Le filtre n’a pas pu se charger. Recharge la page pour réessayer.';
    } finally { grid.removeAttribute('aria-busy'); }
  }

  /* Voir plus de sabres : on ajoute la page suivante sans recharger */
  const more = $('[data-c-more]');
  if (more) more.addEventListener('click', async e => {
    if (hasCustom() || !grid) return;
    e.preventDefault(); if (more.getAttribute('aria-busy') === 'true') return;
    const label = more.textContent; more.setAttribute('aria-busy', 'true'); more.textContent = 'Chargement…';
    try {
      const u = new URL(more.href, location.href); u.searchParams.set('section_id', sectionId);
      const r = await fetch(u.toString(), { credentials: 'same-origin' }); if (!r.ok) throw new Error('page');
      const doc = new DOMParser().parseFromString(await r.text(), 'text/html');
      const fresh = Array.from(doc.querySelectorAll('[data-c-grid] > [data-c-card]'));
      const first = fresh[0] ? document.importNode(fresh[0], true) : null;
      fresh.forEach((c, i) => grid.append(i === 0 && first ? first : document.importNode(c, true)));
      const shownEl = $('[data-c-shown]'), itemsEl = $('[data-c-items]'), fill = $('[data-c-bar-fill]');
      if (shownEl) { const n = Number(shownEl.textContent) + fresh.length; shownEl.textContent = n; if (fill && itemsEl) fill.style.width = Math.min(100, n * 100 / Number(itemsEl.textContent)) + '%'; }
      const next = doc.querySelector('[data-c-more]');
      if (next) { more.href = next.getAttribute('href'); more.textContent = label; more.removeAttribute('aria-busy'); }
      else more.remove();
      if (first) { const a = first.querySelector('a'); if (a && e.detail === 0) a.focus(); }
    } catch (err) { more.textContent = label; more.removeAttribute('aria-busy'); location.href = more.href; }
  });

  /* Barre collante mobile : visible quand la barre de tri est sortie de l'écran */
  const sticky = $('[data-c-sticky]'), bar = $('[data-c-bar]'), main = $('[data-c-main]');
  if (sticky && bar && main && 'IntersectionObserver' in window) {
    let barOut = false, mainIn = false;
    const paint = () => { sticky.hidden = !(barOut && mainIn); };
    new IntersectionObserver(es => { const r = es[0]; barOut = !r.isIntersecting && r.boundingClientRect.top < 0; paint(); }).observe(bar);
    new IntersectionObserver(es => { mainIn = es[0].isIntersecting; paint(); }, { rootMargin: '0px 0px -40% 0px' }).observe(main);
  }

  /* Démarrage */
  if (hasCustom()) applyCustom();
  else if ('requestIdleCallback' in window) requestIdleCallback(() => loadIndex().catch(() => {}), { timeout: 2500 });
  else setTimeout(() => loadIndex().catch(() => {}), 1200);
})();
